module.exports = __webpack_public_path__ + "img/Trash.540b7b50.svg";